import React from 'react';

const UserInfo = ({ userName, companyName }) => (
  <div>
    <h2 className="text-lg font-alexandria font-semibold text-[#111827]">
      {userName || 'Unknown User'}
    </h2>
    {companyName && (
      <p className="text-level-7 font-inter font-normal text-placeholder-text">
      {companyName || ''}
    </p>
    )}
  </div>
);

export default UserInfo;